import $ from 'jquery';

class Collections {
  constructor() {
    const collections = $('*[data-collection]');
    this._insertModal();

    $(document).on('click', '*[data-collection]', (event) => {
      const id = $(event.currentTarget).data('collection');

      const setModal = this._getModal(id);
      // console.log(id);
      const modalBase = $('#modal_add_to_collection');

      setModal.then(data => {
        modalBase.html(data).foundation('open');
      })
    });
  }

  _getModal(id) {
    return $.ajax({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      url: `/${$("html").attr("lang")}/products/${id}/collections/show-modal`,
      type: 'GET',
      dataType: 'HTML',
    })
  }

  _insertModal() {
    const oldModal = $('#modal_add_to_collection');
    if (oldModal.length) {
      $(oldModal).foundation('_destroy').remove();
    };

    $('body').append('<div class="reveal medium c-modal" id="modal_add_to_collection" data-reveal>');
  }
}

export default new Collections;
